import Guard from '@/services/middleware'

const Home = () => import('@/views/dash/settings/department/FormHome.vue')

export default [
    {
        path: '/departamento',
        name: 'department.home',
        component: Home,
        meta: { title: 'Departamento', permission: 2, module: 'mod_department' },
        beforeEnter: [
            Guard.redirectIfNotAuthenticated,
            Guard.checkModuleAccess,
        ],
    },
]
